<template>
    <div class="flex flex-col items-stretch">
        <h2 class="underlined text-xl mt-8">{{ $t('roomshape.title') }}</h2>
        <div class="mt-4">
            {{ $t('roomshape.description') }}
        </div>
        <div class="flex flex-row items-stretch justify-start mt-4 border-l">
            <div @click="setPreset(id)" v-for="(preset, id) in form.constructor.presets" :key="id" class="p-2 px-4 whitespace-no-wrap font-bold border-r border-t cursor-pointer select-none w-full" :class="form.preset_id == id ? 'text-primary bg-white' : 'text-gray-600 border-b'">
                {{ $t(id) }}
            </div>
        </div>
        <div class="bg-white border-l border-r border-b p-4">
            <div v-if="form.isIndividual">
                <hint :title="$t('commons.information')">
                  {{ $t('roomshape.largeproject.description') }}
                </hint>

            </div>
            <img v-else :src="form.preset.image" class="">
        </div>

        <div>
            <!-- Configure Walls -->
            <h2 class="underlined text-xl mt-8">{{ $t('walls.configure') }}</h2>

            <div v-for="wall of form.all_walls" :key="form.all_walls.indexOf(wall)" class="mt-4">
                <wall-configurator :value="wall" @remove="form.removeWall(wall)" :individual="form.isIndividual" :form="form"></wall-configurator>
            </div>

            <div v-if="form.isIndividual" @click="form.addWall()" class="text-center p-2 mt-4 uppercase font-bold cursor-pointer select-none">
                + {{ $t('walls.add') }}
            </div>

            <!-- Configure Formteile -->
            <h2 class="underlined text-xl mt-8">{{ $t('moulded-parts.title') }}</h2>

            <div class="bg-white border mt-4">
                <div class="p-4">{{ $t('moulded-parts.notice') }}</div>
            </div>

            <!-- Formteile summary (do not display this anymore) -->
            <!--
            <template v-if="false">
                <moulded-parts :form="form" class="mt-4"></moulded-parts>

                <-- Upload sketch -- >
                <h2 class="underlined text-xl mt-8">{{ $t('roomshape.sketch') }}</h2>
                <div class="bg-white border mt-4">

                    <div class="p-4">
                        {{ $t('roomshape.individual.description') }}
                        <br>

                        <input type="file" class="w-full h-32 bg-white border border-dashed rounded p-4 mt-4" @input="setImage">

                        <div class="mt-4"><b>{{ $t('commons.example') }}:</b></div>
                        <div><img :src="IndividualRoomImage[$i18n.locale]" alt=""></div>
                    </div>
                </div>
            </template>
-->


            <!-- Summary -->
            <div v-if="form.areWallsValid()">
                <h2 class="underlined text-xl mt-8">{{ $t('summary.title') }}</h2>
                <Summary :summary="form.summary" class="mt-4 border bg-white"></Summary>
            </div>
        </div>
        <div class="flex flex-row-reverse items-start justify-between mt-8">
            <div @click="$router.push({ name: 'informations' })" class="bg-primary text-white px-4 py-2 flex flex-row items-center uppercase font-bold tracking-wide cursor-pointer select-none">
                {{ $t('commons.continue') }}
                <div class="border-t-2 border-r-2 border-white h-2 w-2 ml-2" :style="{ transform: 'rotate(45deg)' }"></div>
            </div>
        </div>
    </div>
</template>

<script>
import Form from '@/models/Form'
import WallConfigurator from '@/components/WallConfigurator'
import MouldedParts from '@/components/MouldedParts'
import Summary from '@/components/Summary'
import IndividualRoomImage from '@/assets/images/Raum/Individual'
import Hint from '@/components/Hint'

export default {
    components: { WallConfigurator, MouldedParts, Summary, Hint },
    props: {
        // form: Object,
    },
    data() {
        return {
            form: new Form(),
            IndividualRoomImage
        };
    },
    mounted() {
        console.log(this.form.formteile.innenecken);

        this.form.formteile.innenecken = 6;
    },
    methods: {
        // room shape changed. Fill values with the preset for the room
        setPreset(id) {
            this.form.preset_id = id;
            this.form.formteile = this.form.formteilePreset;
        },
        removeWall(wall) {
            this.form.removeWall(wall)
        },
        setImage({ target: { files: [ image ] } }) {
            const reader = new FileReader();
            reader.onloadend = () => {
                this.form.image = reader.result;
            }
            reader.readAsDataURL(image);
        },
    },
}
</script>

<style lang="stylus">
table.table
    tr
        td
            @apply p-2
        td:first-child
            @apply text-right font-bold
</style>
